import { ISearchUsersByAdminResponse, IUserResponse } from '@joc/api-gateway';
import update from 'immutability-helper';

import {
	DELETE_USER,
	GET_COMPANIES_USERS_ADMIN,
	GET_COMPANIES_USERS_ALL,
	GET_COMPANIES_USERS_COORDINATORS,
	GET_COMPANIES_USERS_MARKETERS,
	GET_COMPANIES_USERS_TOTALS,
	RESET_COMPANIES_USERS,
	SET_USER_POSITION,
	SET_USER_ROLE,
	UNSET_USER_ROLE,
	UPDATE_USER_DATA,
} from 'redux/actions-types';
import { CompaniesUsersActions, CompaniesUsersReducer, CompaniesUsersResponsePayload } from './types';

const initialState: CompaniesUsersReducer = {
	records: [],
	totals: {
		all: 0,
		admins: 0,
		coordinators: 0,
		marketers: 0,
	},
	total: 0,
};

const mergeUniqueRecords = (existing: IUserResponse[], incoming: IUserResponse[]) => {
	const existingIds = new Set(existing.map(u => u.id));
	const uniqueIncoming = incoming.filter(u => !existingIds.has(u.id));
	return [...existing, ...uniqueIncoming];
};

const companiesUsersReducer = (state = initialState, action: CompaniesUsersActions) => {
	const { type, payload } = action;

	switch (type) {
		case GET_COMPANIES_USERS_ALL: {
			const { records, total, replace } = payload as CompaniesUsersResponsePayload;
			return {
				...state,
				records: replace ? records : mergeUniqueRecords(state.records, records),
				total,
			};
		}
		case GET_COMPANIES_USERS_ADMIN: {
			const { records, total, replace } = payload as CompaniesUsersResponsePayload;
			return {
				...state,
				records: replace ? records : mergeUniqueRecords(state.records, records),
				total,
			};
		}
		case GET_COMPANIES_USERS_COORDINATORS: {
			const { records, total, replace } = payload as CompaniesUsersResponsePayload;
			return {
				...state,
				records: replace ? records : mergeUniqueRecords(state.records, records),
				total,
			};
		}
		case GET_COMPANIES_USERS_MARKETERS: {
			const { records, total, replace } = payload as CompaniesUsersResponsePayload;
			return {
				...state,
				records: replace ? records : mergeUniqueRecords(state.records, records),
				total,
			};
		}
		case GET_COMPANIES_USERS_TOTALS: {
			return { ...state, totals: { ...state.totals, ...payload } };
		}
		case RESET_COMPANIES_USERS: {
			return { ...state, records: initialState.records, total: initialState.total };
		}
		case SET_USER_ROLE: {
			const indexUser = state.records.findIndex(i => +i.id === +(payload as IUserResponse).id);
			if (indexUser === -1) return state;
			return update(state, { records: { [indexUser]: { $merge: payload as IUserResponse } } });
		}
		case UNSET_USER_ROLE: {
			const indexUser = state.records.findIndex(i => +i.id === +(payload as IUserResponse).id);
			if (indexUser === -1) return state;
			return update(state, { records: { [indexUser]: { $merge: payload as IUserResponse } } });
		}
		case SET_USER_POSITION: {
			const indexUser = state.records.findIndex(i => +i.id === +(payload as IUserResponse).id);
			if (indexUser === -1) return state;
			return update(state, { records: { [indexUser]: { $merge: payload as IUserResponse } } });
		}
		case UPDATE_USER_DATA: {
			const index = state.records.findIndex(item => +item.id === +(payload as IUserResponse).id);
			if (index === -1) return state;
			return update(state, {
				records: { [index]: { $set: payload as IUserResponse } },
			});
		}
		case DELETE_USER: {
			const index = state.records.findIndex(item => +item.id === Number(payload));
			if (index === -1) return state;
			return {
				...state,
				records: state.records.filter(item => +item.id !== Number(payload)),
				total: Math.max(0, state.total - 1),
			};
		}

		default:
			return state;
	}
};

export default companiesUsersReducer;
